import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { addLocale, replace } from '../misc';
import request, { apiHost } from '../utils/request';
import { CONSTANT } from '../utils/constant';
import { useLocaleContext } from '../context/LocaleContext';
import {
  LoginContainer,
  LoginHeader,
  Title,
  Description,
  CardContainer,
  LoginButtonSecondary,
  SeparatorMain,
  SeparatorText,
  LinkContainer,
  LinkText,
  LinkUrl,
  LinkWrapper
} from './css';

import '../../assets/css/login.css';
import '../../assets/css/login_media_queries.css';
import CustomLogin from './customLogin';

const Login = ({ history }) => {
  const queryData = new URLSearchParams(history.location.search);

  const isPasswordChangeRequired = request.getPasswordUpdate();
  const locale = useLocaleContext();
  const addLocaleToUrl = addLocale(locale);

  const {
    KEYS: { ROLES }
  } = CONSTANT;

  const getRedirectUrl = role => {
    let redirectUrl = '/';
    switch (role) {
      case ROLES.SOV_ADMIN:
      case ROLES.SOV_AGENT: {
        redirectUrl = '/orders';
        break;
      }
      case ROLES.PRODUCT_TEAM: {
        redirectUrl = '/quote-approval';
        break;
      }
      default:
        break;
    }
    const valueMoveToDefects = localStorage.getItem('moveToDefects');
    if (
      valueMoveToDefects &&
      valueMoveToDefects !== null &&
      valueMoveToDefects !== 'null'
    ) {
      const { search } = JSON.parse(valueMoveToDefects) || {};
      redirectUrl = `/report-an-issue${search || ''}`;
      localStorage.removeItem('moveToDefects');
    }
    return redirectUrl;
  };

  const getUserProfile = () => {
    return request.get('/users/profile');
  };

  const clearUnRequiredLocalStorage = () => {
    const moveToDefectData = localStorage.getItem('moveToDefects');
    localStorage.clear();
    localStorage.setItem('moveToDefects', moveToDefectData);
  };

  useEffect(() => {
    const authenticate = async () => {
      const redirect = (changePassword, userProfile, url) => {
        if (JSON.parse(changePassword)) {
          history.push(addLocaleToUrl('/update-password'));
        } else if (url && url.length > 0) {
          try {
            const urlObj = JSON.parse(JSON.parse(url).url);
            history.push(
              addLocaleToUrl(
                `/${replace(urlObj.name)}/${replace(urlObj.formField.name)}/`
              )
            );
          } catch (err) {
            history.push(addLocaleToUrl(getRedirectUrl(userProfile.role.name)));
          }
        } else {
          history.push(addLocaleToUrl(getRedirectUrl(userProfile.role.name)));
        }

        // HACK to fix: header issue ideally
        // TODO need to remove this reload
        window.location.reload();
      };

      //  check if user is redirected from passport with token in params
      const token = queryData.get('token');
      const changePassword = JSON.parse(
        queryData.get('changePassword') || false
      );
      const url = decodeURIComponent(queryData.get('url') || '');

      // check if already logged in
      if (request.getToken() && request.getProfile())
        redirect(isPasswordChangeRequired, request.getProfile(), url);
      else if (token) {
        request.setToken(token);
        request.setPasswordUpdate(changePassword);
        try {
          const { data } = await getUserProfile();
          request.setProfile(data);
          request.setSSOLoginState(true);
          redirect(changePassword, data, url);
        } catch (err) {
          localStorage.clear();
        }
      } else clearUnRequiredLocalStorage();
    };

    authenticate();
  }, [request.getToken()]);

  return (
    <LoginContainer>
      <LoginHeader>
        <Title>Welcome to Capture</Title>
        <Description>
          Please select the applicable login method from the options below.
        </Description>
      </LoginHeader>
      <CardContainer>
        <CustomLogin history={history} />
        <SeparatorMain>
          <SeparatorText>OR</SeparatorText>
        </SeparatorMain>
        <LoginButtonSecondary
          onClick={() => window.location.replace(`${apiHost}/users/sso-login`)}
        >
          TELUS SSO
        </LoginButtonSecondary>
        <LoginButtonSecondary
          onClick={() =>
            window.location.replace(`${apiHost}/users/sso-login-partners`)
          }
        >
          Partner SSO
        </LoginButtonSecondary>
        <LinkWrapper>
          <LinkContainer>
            <LinkText>Forgot Password?</LinkText>
            <Link to="/forgot-password">
              <LinkUrl>Reset Here</LinkUrl>
            </Link>
          </LinkContainer>
          <LinkContainer>
            <LinkText>New to Capture?</LinkText>
            <Link to="/registration">
              <LinkUrl>Register Now</LinkUrl>
            </Link>
          </LinkContainer>
        </LinkWrapper>
      </CardContainer>
    </LoginContainer>
  );
};

Login.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
    location: PropTypes.shape({
      search: PropTypes.string.isRequired
    }).isRequired
  }).isRequired
};
export default Login;
